/* eslint-disable no-unused-vars */
import { useState, useCallback } from "react";

type UseArrayStateReturn<T> = {
  items: T[];
  append: (item: T) => void;
  update: (index: number, item: Partial<T>) => void;
  remove: (index: number) => void;
  set: (items: T[]) => void;
};

function useArrayState<T>(initial: T[] = []): UseArrayStateReturn<T> {
  const [items, setItems] = useState<T[]>(initial);

  const append = useCallback((item: T) => {
    setItems((prev) => [...prev, item]);
  }, []);

  const update = useCallback((index: number, item: Partial<T>) => {
    setItems((prev) =>
      prev.map((el, i) => (i === index ? { ...el, ...item } : el)),
    );
  }, []);

  const remove = useCallback((index: number) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const set = useCallback((items: T[]) => {
    setItems(items);
  }, []);

  return { items, append, update, remove, set };
}

export { useArrayState };
